import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import SourceIcon from "@mui/icons-material/Source";
import FilterTiltShift from "@mui/icons-material/FilterTiltShift";
import StorageIcon from "@mui/icons-material/Storage";
import SearchIcon from "@mui/icons-material/Search";
import ArchiveIcon from "@mui/icons-material/Archive";
import UnarchiveIcon from "@mui/icons-material/Unarchive";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import AppHeader from "../appHeader";
import { NavLink } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getNotificationsSelector } from "../../../store/alert/selectors";
import { Alert, Button, Tooltip } from "@mui/material";
import { INotification } from "../../../store/alert/types";
import { IProfile } from "../../../store/userProfile/types";

import {
  removeAllSnackbar,
  removeSnackbar,
} from "../../../store/alert/actions";
import { SnackbarKey } from "notistack";
import { getRoleClaimsSelector } from "../../../store/auth/selectors";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";

import { ISpokeDetails } from "../../../store/spokes/types";
import { getProfileSelector } from "../../../store/userProfile/selectors";
import { fetchSpokeListSelector } from "../../../store/spokes/selectors";
interface NavigationItem {
  key?: string;
  title: string;
  icon: React.JSX.Element;
  navigation: string;
  hubAdmin: boolean;
  spokeAdmin: boolean;
  normalUser: boolean;
}

interface INavProps {
  toggleNavigationPane:
  | (() => void)
  | ((event: React.KeyboardEvent | React.MouseEvent) => void);
}

interface INotificationProps {
  toggleNotificationPane:
  | (() => void)
  | ((event: React.KeyboardEvent | React.MouseEvent) => void);
}

export const navigationLabels = {
  MyAssets: "My Assets",
  DataSets: "Search Data",
  DataSources: "Data Sources",
  DataExtractors: "Data Extractors",
  DataTargets: "Data Targets",
  InsituCriticality: "InSitu Criticality",
  ManageOverrides: "Overrides",
  OverrideRequests: "Override Requests",
  ResourceExplorer: "Resource Explorer",
  Spokes: "Spokes",
};

export const NavigationItems = (props: INavProps) => {
  const { toggleNavigationPane } = props;
  const [isAdmin, setIsAdmin] = useState(true);

  // roles  - IDP.Admin or IDP.User
  const roles: string[] = useSelector(getRoleClaimsSelector);

  useEffect(() => {
    if (roles && roles.length > 0) {
      setIsAdmin(roles.includes("IDP.Admin") ? true : false);
    }
  }, [roles]);

  //    ************ spoke based access controls ****************
  const userProfile: IProfile[] = useSelector(getProfileSelector);
  const getSpokeList = useSelector(fetchSpokeListSelector);

  const [spokeProfile, setSpokeProfile] = useState<any>();
  const [spokeList, setSpokeList] = useState<any>();

  useEffect(() => {
    if (userProfile && userProfile.length > 0) {
      setSpokeProfile(userProfile);
    }
  }, [userProfile]);

  useEffect(() => {
    if (getSpokeList && getSpokeList.length > 0) {
      setSpokeList(getSpokeList);
    }
  }, [getSpokeList]);
  const isSpokeAdmin = () => {
    const getSpokeAdmin: any = [];
    spokeList &&
      spokeList.map((x: ISpokeDetails) => {
        return (
          spokeProfile &&
          spokeProfile.map((y: IProfile) => {
            return getSpokeAdmin.push(y.adGroupName === x.adminGroupName);
          })
        );
      });

    // check if any value has been returned as true (that means the user is an admin of some spoke), if there is a match (indicated by true) then return regular user as false else display true
    return getSpokeAdmin.some(Boolean);
  };
  //    ************ end spoke based access controls ****************

  const navigationItemsList: NavigationItem[] = [
    {
      title: navigationLabels.MyAssets,
      icon: <SourceIcon />,
      navigation: "/MyAssets",
      hubAdmin: true,
      spokeAdmin: true,
      normalUser: true,
    },
    {
      title: navigationLabels.DataSets,
      icon: <SearchIcon />,
      navigation: "/SearchData",
      hubAdmin: true,
      spokeAdmin: true,
      normalUser: true,
    },
    {
      title: navigationLabels.DataSources,
      icon: <UnarchiveIcon />,
      navigation: "/DataSourceList",
      hubAdmin: true,
      spokeAdmin: true,
      normalUser: true,
    },
    {
      title: navigationLabels.DataExtractors,
      icon: <StorageIcon />,
      navigation: "/DataExtractorList",
      hubAdmin: isAdmin,
      spokeAdmin: isSpokeAdmin(),
      normalUser: false,
    },
    {
      title: navigationLabels.DataTargets,
      icon: <ArchiveIcon />,
      navigation: "/DataTargetList",
      hubAdmin: true,
      spokeAdmin: true,
      normalUser: true,
    },
    {
      title: navigationLabels.InsituCriticality,
      icon: <StorageIcon />,
      navigation: "/InsituExtractorList",
      hubAdmin: true,
      spokeAdmin: true,
      normalUser: true,
    },
    {
      title: navigationLabels.ManageOverrides,
      icon: <PeopleAltIcon />,
      navigation: "/OverRideList",
      hubAdmin: isAdmin,
      spokeAdmin: false,
      normalUser: false,
    },
    {
      title: navigationLabels.OverrideRequests,
      icon: <PeopleAltIcon />,
      navigation: "/OverrideRequestList",
      hubAdmin: isAdmin,
      spokeAdmin: false,
      normalUser: false,
    },
    {
      title: navigationLabels.Spokes,
      icon: <FilterTiltShift />,
      navigation: "/SpokeList",
      hubAdmin: isAdmin,
      spokeAdmin: isSpokeAdmin(),
      normalUser: false,
    },
    {
      title: navigationLabels.ResourceExplorer,
      icon: <SearchIcon />,
      navigation: "/ResourceExplorer",
      hubAdmin: isAdmin,
      spokeAdmin: isSpokeAdmin(),
      normalUser: false,
    },
  ];

  return (
    <Box
      sx={{ width: 260 }}
      role="presentation"
      onClick={toggleNavigationPane}
      onKeyDown={toggleNavigationPane}
    >
      <List>
        {navigationItemsList.map((item) => {
          if (item.hubAdmin || item.spokeAdmin || item.normalUser) {
            //future logic for showing admin only items.
            return (
              <NavLink
                key={item.title}
                to={item.navigation}
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <ListItem button key={item.title}>
                  <ListItemIcon>{item.icon}</ListItemIcon>
                  <ListItemText primary={item.title} />
                </ListItem>
              </NavLink>
            );
          }
          return null;
        })}
      </List>
    </Box>
  );
};

// create notification list - here

export const NotificationItems = (props: INotificationProps) => {
  const { toggleNotificationPane } = props;
  const [notifications, setNotifications] = useState<INotification[]>([]);
  const dispatch = useDispatch();

  const notificationsList = useSelector(getNotificationsSelector);

  useEffect(() => {
    setNotifications(notificationsList);
  }, [notificationsList]);

  const handleCloseAlert = (key: SnackbarKey) => {
    dispatch(removeSnackbar(key));
  };

  return (
    <Box
      sx={{ width: 480 }}
      role="presentation"
      onKeyDown={toggleNotificationPane}
    >
      <List>
        {notifications
          .slice(0)
          .reverse()
          .map((item) => {
            return (
              <ListItem button key={item.key}>
                <Alert
                  severity={
                    item.options.variant !== "default"
                      ? item.options.variant
                      : "info"
                  }
                  onClose={() => handleCloseAlert(item.key!)}
                >
                  {item.message}
                  &nbsp; &nbsp;
                  <Tooltip title="Copy to clipboard">
                    <ContentCopyOutlinedIcon
                      fontSize="small"
                      onClick={() => {
                        navigator.clipboard.writeText(item.message);
                      }}
                    />
                  </Tooltip>
                </Alert>
              </ListItem>
            );
          })}
      </List>
    </Box>
  );
};

export const NavigationPane = () => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [isNotification, setIsNotification] = useState(false);

  const toggleDrawer =
    (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event.type === "keydown" &&
        ((event as React.KeyboardEvent).key === "Tab" ||
          (event as React.KeyboardEvent).key === "Shift")
      ) {
        return;
      }

      setIsOpen(open);
    };

  const toggleNotificationDrawer =
    (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event.type === "keydown" &&
        ((event as React.KeyboardEvent).key === "Tab" ||
          (event as React.KeyboardEvent).key === "Shift")
      ) {
        return;
      }

      setIsNotification(open);
    };

  const handleRemoveAll = () => {
    dispatch(removeAllSnackbar());
    setIsNotification(false);
  };

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppHeader
        toggleNavigationPane={toggleDrawer(!isOpen)}
        toggleNotifications={toggleNotificationDrawer(!isNotification)}
      />
      <Drawer
        open={isOpen}
        onClose={toggleDrawer(false)}
        sx={{
          [`& .MuiDrawer-paper`]: {
            boxSizing: "border-box",
            backgroundColor: "#DDDDDD",
            minWidth: "260px",
          },
        }}
      >
        <Toolbar id="toolbar" />
        <Box sx={{ overflow: "auto" }}>
          <NavigationItems toggleNavigationPane={toggleDrawer(false)} />
        </Box>
      </Drawer>
      <Drawer
        anchor="right"
        open={isNotification}
        onClose={toggleNotificationDrawer(false)}
        sx={{
          [`& .MuiDrawer-paper`]: {
            boxSizing: "border-box",
            backgroundColor: "#DDDDDD",
            minWidth: "300px",
          },
        }}
      >
        <Toolbar />
        <Box sx={{ overflow: "auto", textAlign: "center", padding: "10px 0" }}>
          <Button id="aa5948f9-0813-4232-9ede-86f065571af3" onClick={handleRemoveAll}>Remove All</Button>
          <NotificationItems
            toggleNotificationPane={toggleNotificationDrawer(false)}
          />
        </Box>
      </Drawer>
    </Box>
  );
};

export default NavigationPane;
